import {
    RESET_GROUP_PAGE,
    FETCH_GROUP_LEADERBOARD,
    FETCH_GROUP_LEADERBOARD_FAILED,
    FETCH_GROUP_LEADERBOARD_SUCCESS,
    SET_GROUP_LEADERBOARD_TYPE,
    SET_GROUP_LEADERBOARD_VIEW_PREVIOUS
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    fetching: true,
    error: false,
    viewPrevious: false,
    leaderboardType: '',
    list: null
};

/** selector */

export const selectGroupLeaderboard = (state) => state.groupPageLeaderboard;

export const selectGroupLeaderboardFetching = (state) => {
    const leaderboard = selectGroupLeaderboard(state);
    return leaderboard.fetching;
};

export const selectGroupLeaderboardType = (state) => {
    const leaderboard = selectGroupLeaderboard(state);
    return leaderboard.leaderboardType;
};

export const selectGroupLeaderboardViewPrevious = (state) => {
    const leaderboard = selectGroupLeaderboard(state);
    return leaderboard.viewPrevious;
};

export const selectGroupLeaderboardList = (state) => {
    const leaderboard = selectGroupLeaderboard(state);
    return leaderboard.list;
};

/** action handlers */
const setGroupLeaderboardType = (state, action) => {
    return {
        ...state,
        leaderboardType: action.leaderboardType
    };
};

const setGroupLeaderboardViewPrevious = (state, action) => {
    return {
        ...state,
        viewPrevious: action.viewPrevious
    };
};

const fetchGroupLeaderboard = (state) => {
    return {
        ...state,
        fetching: true,
        error: false,
        list: null
    };
};

const fetchGroupLeaderboardSuccess = (state, action) => {
    return {
        ...state,
        fetching: false,
        error: false,
        list: action.list
    };
};

const fetchGroupLeaderboardFailed = (state) => {
    return {
        ...state,
        fetching: false,
        error: true
    };
};

const resetGroupPage = () => {
    return INITIAL_STATE;
};

const handlers = {
    [SET_GROUP_LEADERBOARD_TYPE]: setGroupLeaderboardType,
    [SET_GROUP_LEADERBOARD_VIEW_PREVIOUS]: setGroupLeaderboardViewPrevious,
    [FETCH_GROUP_LEADERBOARD]: fetchGroupLeaderboard,
    [FETCH_GROUP_LEADERBOARD_SUCCESS]: fetchGroupLeaderboardSuccess,
    [FETCH_GROUP_LEADERBOARD_FAILED]: fetchGroupLeaderboardFailed,
    [RESET_GROUP_PAGE]: resetGroupPage
};

export default function groupPageLeaderboardReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
